<div class="lot-form">
    <cb-lot-migrator-address-section
        [lotForm]="lotForm"
        [addressRegions]="addressRegions"
    ></cb-lot-migrator-address-section>

    <mat-divider></mat-divider>

    <cb-lot-migrator-lot-build-section
        [lotForm]="lotForm"
        [buildTypeOptions]="buildTypeOptions"
        [contractTypes]="contractTypes"
        [lotTypes]="lotTypes"
    ></cb-lot-migrator-lot-build-section>
</div>
